import { CitableFaq } from "../components/CitableFaq";
import { LegalPageLayout, Section } from "../components/legal/LegalPageLayout";
import { faqPageFaq } from "../content/geo-content";

export function FAQ() {
  return (
    <LegalPageLayout
      title="Haeufige Fragen zur Ladeinfrastruktur-Regulierung"
      lastUpdated="22. April 2026"
      crossLink={{ to: "/", label: "Zurueck zur Startseite" }}
      contactEmail="contact@chargesuite.de"
    >
      <Section id="faq-intro" title="Was CPOs jetzt wissen muessen">
        <p>
          Die Regulierungslandschaft fuer Ladepunktbetreiber hat sich 2024
          grundlegend geaendert. Hier beantworten wir die 12 haeufigsten Fragen
          — paragrafengenau.
        </p>
      </Section>
      <Section id="faq-items" title="Fragen und Antworten">
        <CitableFaq items={faqPageFaq} />
      </Section>
      <Section id="faq-cta" title="Ihren Compliance-Status pruefen">
        <p>
          Nicht sicher, ob Ihre Anlage alle Anforderungen erfuellt?{" "}
          <a
            href="/audit"
            style={{ color: "var(--color-primary)" }}
            className="font-semibold hover:underline"
          >
            Jetzt kostenlose Compliance-Pruefung starten
          </a>{" "}
          — ChargeSuite prueft 188 Anforderungen aus 7 Verordnungen automatisch.
        </p>
      </Section>
    </LegalPageLayout>
  );
}
